<ion-content scrollX="true" class="component-container">
  <ion-header class="component-header ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="start" class="">
        <ion-title class="ion-no-padding component-title">Inventory Itinerary</ion-title>
        <ion-button class="unfilled-red-btn-sm ms-2" *ngIf="gridViewComponent?.areRowsSelected()" (click)="deleteMultipleRow()">Delete</ion-button>
      </ion-buttons>
      <ion-buttons slot="end" class="filters-main-container">


        <ion-button class="filter-btn" [ngClass]="{'filter-applied': inventoryFilters?.destination?.length}" (click)="openDestinationFiltersPopup($event, 'destination', ENTITY_NAMES.QUOTE_STATUS, 'destination')">
          <ion-text class="me-1">Destination</ion-text>
          <ion-text *ngIf="inventoryFilters?.destination?.length">(+{{inventoryFilters?.destination?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': inventoryFilters?.totalDays?.length}" (click)="openFiltersPopup($event, 'name', 'Nights', 'totalDays')">
          <ion-text class="me-1">Nights</ion-text>
          <ion-text *ngIf="inventoryFilters?.totalDays?.length">(+{{inventoryFilters?.totalDays?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <ion-button class="filter-btn" [ngClass]="{'filter-applied': inventoryFilters?.status?.length}" (click)="openFiltersPopup($event, 'name', ENTITY_NAMES.INVENTORY_STATUS, 'status')">
          <ion-text class="me-1">Status</ion-text>
          <ion-text *ngIf="inventoryFilters?.status?.length">(+{{inventoryFilters?.status?.length}})</ion-text>
          <ion-icon name="caret-down-outline"></ion-icon>
        </ion-button>

        <div>
          <!-- TODO: use date picker here -->
          <input class="date-filter" type="date" [(ngModel)]="fromDate" [max]="today" (ngModelChange)="onFromDateChange($event)">
          <!-- <app-date-picker class="filter" type="date" [(ngModel)]="fromDate" [maxDate]="today" (ngModelChange)="onFromDateChange($event)"></app-date-picker> -->
        </div>
        
        <div>
          <label for="" class="label px-1">To</label>
        </div>
        
        <div>
          <input class="date-filter" type="date" [(ngModel)]="toDate" [disabled]="!fromDate" [min]="fromDate" [max]="today" (ngModelChange)="onToDateChange($event)">
        </div>

        <ion-button class="unfilled-red-btn" (click)="clearFilters()">
          <ion-text>Clear All</ion-text>
        </ion-button>
       

      </ion-buttons>
      <ion-buttons slot="end" class="">
        <ion-button [ngStyle]="{ 'display': showItineraryButton ? 'block' : 'none' }" class="filled-blue-btn" id="open-custom-dialog" (click)="openNewItineraryForm()">
          <div class="heder-end-button" >
            <ion-icon name="add-outline"></ion-icon>
            <ion-text>Create Itinerary</ion-text>
          </div>
        </ion-button>
        <ion-button class="filled-blue-btn" id="open-custom-dialog" (click)="downloadInventoryCSV()" *ngIf="originalInventoryList?.length > 0">
          <div class="heder-end-button">
            <ion-icon name="download-outline"></ion-icon>
          </div>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <div class="p-1 w-100 overflow-auto component-content">
    <app-inventory-itinerary-grid-view
    [allData]="allInventoryItineraryData" 
    [columns]="allInventoryItineraryColumns" 
    (manageColumnsChange)="manageColumnsChanged($event)" 
    (triggerDeleteRow)="deleteItineraryRow($event)" 
    (paginationsUpdated)="updatePagination($event)"
    (triggerEditRow)="editItineraryOpen($event)" 
    (triggerViewRow)="viewInventoryItinerary($event)"
    (triggerAuditRow)="showAuditHistory($event)"
    [multiSelectProperty]="'itineraryId'"
    ></app-inventory-itinerary-grid-view>
  </div>
  
</ion-content>